module.exports = __webpack_public_path__ + "static/media/fly0162.40787564.webp";